var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('CoverPage'),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }